import {FC} from 'react';
import cn from 'classnames';

import {CategoryTier} from '@/modules/FinancialHealthScore/scoring';

import {buildWedgePath} from '../../../../utils';

import styles from './styles.module.scss';

interface DialSegmentProps {
  index: number;
  filled: boolean;
  tier: CategoryTier;
}

const DialSegment: FC<DialSegmentProps> = ({index, filled, tier}) => {
  const className = cn(styles.dialSegment, {
    [styles.dialSegment__modUnfilled]: !filled,
    [styles.dialSegment__modLookingGood]: filled && tier === 'looking-good',
    [styles.dialSegment__modWorthLook]: filled && tier === 'worth-a-look',
    [styles.dialSegment__modNeedsAttention]:
      filled && tier === 'needs-attention',
  });

  return <path d={buildWedgePath(index)} className={className} />;
};

export default DialSegment;
